module.exports = __webpack_public_path__ + "bm.svg?e0a5a6bf1f2775704fd530e3c97af833";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bm.svg
// module id = 1009
// module chunks = 27